// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ENbvt","left":"styles_left__X4AVK","desktopActions":"styles_desktopActions__euVmG","title":"styles_title__ruiEG"};